import * as v from 'valibot';

const LocusRails = v.object({
  locus_id: v.optional(v.nullable(v.string())),
  locus_type: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
  locus_v2_id: v.optional(v.nullable(v.string())),
  locus_v2_type: v.optional(v.nullable(v.string())),
});

const LocationRails = v.object({
  code: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
  country_code: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
});

const FromRails = v.object({
  locus: v.optional(v.nullable(LocusRails)),
  location: v.optional(v.nullable(LocationRails)),
});

const ToRails = v.object({
  locus: v.optional(v.nullable(LocusRails)),
  location: v.optional(v.nullable(LocationRails)),
});

const SearchContextRails = v.object({
  from: v.optional(v.nullable(FromRails)),
  to: v.optional(v.nullable(ToRails)),
  from_date_time: v.optional(v.nullable(v.number())),
  travel_class: v.optional(v.nullable(v.string())),
  pax: v.optional(v.nullable(v.object({
    count: v.optional(v.nullable(v.number())),
    details: v.optional(v.nullable(v.object({
      child: v.optional(v.nullable(v.object({
        count: v.optional(v.nullable(v.number())),
        ages: v.optional(v.nullable(v.array(v.any()))),
      }))),
      adult: v.optional(v.nullable(v.object({
        count: v.optional(v.nullable(v.number())),
      }))),
      infant: v.optional(v.nullable(v.object({
        count: v.optional(v.nullable(v.number())),
      }))),
    }))),
  }))),
  advance_purchase: v.optional(v.nullable(v.number())),
});

const AddonDetailsItemRails = v.object({
  addon_type: v.optional(v.nullable(v.string())),
  addontype: v.optional(v.nullable(v.string())),
  id: v.optional(v.nullable(v.string())),
  currency: v.optional(v.nullable(v.string())),
  included_units: v.optional(v.nullable(v.number())),
  includedunits: v.optional(v.nullable(v.number())),
  unit_price: v.optional(v.nullable(v.number())),
  unitprice: v.optional(v.nullable(v.number())),
  unit_type: v.optional(v.nullable(v.string())),
  unittype: v.optional(v.nullable(v.string())),
  heading: v.optional(v.nullable(v.string())),
  selected: v.optional(v.nullable(v.boolean())),
  available: v.optional(v.nullable(v.boolean())),
  is_preselected: v.optional(v.nullable(v.boolean())),
  refund_amount: v.optional(v.nullable(v.number())),
  premium_percentage: v.optional(v.nullable(v.number())),
  variant: v.optional(v.nullable(v.number())),
  discount: v.optional(v.nullable(v.number())),
  description: v.optional(v.nullable(v.string())),
});

const EventTrackingContextRails = v.object({
  bu: v.optional(v.nullable(v.string())),
  domain_country: v.optional(v.nullable(v.string())),
  domain_currency: v.optional(v.nullable(v.string())),
  domain_language: v.optional(v.nullable(v.string())),
  env: v.optional(v.nullable(v.string())),
  funnel_source: v.optional(v.nullable(v.string())),
  journey_id: v.optional(v.nullable(v.string())),
  organisation: v.optional(v.nullable(v.string())),
  session_id: v.optional(v.nullable(v.string())),
  session_visit_number: v.optional(v.nullable(v.number())),
  template_id: v.optional(v.nullable(v.number())),
  timezone: v.optional(v.nullable(v.string())),
  topic_name: v.optional(v.nullable(v.string())),
  traffic_source: v.optional(v.nullable(v.string())),
  user_preferred_currency: v.optional(v.nullable(v.string())),
  preferred_country: v.optional(v.nullable(v.string())),
});

const SeenItemRails = v.object({
  group: v.optional(v.nullable(v.string())),
  range_filter: v.optional(v.nullable(v.boolean())),
  category: v.optional(v.nullable(v.string())),
  value: v.optional(v.nullable(v.string())),
});

const CatalogItemRails = v.object({
  quota: v.optional(v.nullable(v.string())),
  class_name: v.optional(v.nullable(v.string())),
  price: v.optional(v.nullable(v.object({
    total_amount: v.optional(v.nullable(v.number())),
  }))),
  status: v.optional(v.nullable(v.string())),
  date: v.optional(v.nullable(v.string())),
  availability_last_updated: v.optional(v.nullable(v.string())),
  free_cancellation_available: v.optional(v.nullable(v.boolean())),
  trip_guarantee_available: v.optional(v.nullable(v.boolean())),
  trip_gaurantee_available: v.optional(v.nullable(v.boolean())),
  source_of_data: v.optional(v.nullable(v.string())),
});

const LegRails = v.object({
  id: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
  number: v.optional(v.nullable(v.string())),
  product_type: v.optional(v.nullable(v.string())),
  duration: v.optional(v.nullable(v.number())),
  category: v.optional(v.nullable(v.string())),
  sku_type: v.optional(v.nullable(v.string())),
  is_cluster: v.optional(v.nullable(v.boolean())),
  is_dynamic_pricing_applicable: v.optional(v.nullable(v.boolean())),
  availability_shown: v.optional(v.nullable(v.string())),
  fare_shown: v.optional(v.nullable(v.number())),
  from_station: v.optional(v.nullable(v.object({
    code: v.optional(v.nullable(v.string())),
    name: v.optional(v.nullable(v.string())),
    departure_time: v.optional(v.nullable(v.string())),
    departure_date: v.optional(v.nullable(v.string())),
  }))),
  to_station: v.optional(v.nullable(v.object({
    code: v.optional(v.nullable(v.string())),
    name: v.optional(v.nullable(v.string())),
    arrival_time: v.optional(v.nullable(v.string())),
    arrival_date: v.optional(v.nullable(v.string())),
  }))),
  boarding_station: v.optional(v.nullable(v.object({
    code: v.optional(v.nullable(v.string())),
    name: v.optional(v.nullable(v.string())),
    departure_time: v.optional(v.nullable(v.string())),
    departure_date: v.optional(v.nullable(v.string())),
  }))),
  catalog_list: v.optional(v.nullable(v.array(CatalogItemRails))),
});

const ProductItemRails = v.object({
  id: v.optional(v.nullable(v.string())),
  duration: v.optional(v.nullable(v.number())),
  rank: v.optional(v.nullable(v.number())),
  legs: v.optional(v.nullable(v.array(LegRails))),
  // Additional fields for thank you page
  train_number: v.optional(v.nullable(v.string())),
  train_name: v.optional(v.nullable(v.string())),
  total_fare: v.optional(v.nullable(v.number())),
  from_station: v.optional(v.nullable(v.object({
    code: v.optional(v.nullable(v.string())),
    name: v.optional(v.nullable(v.string())),
    departure_date: v.optional(v.nullable(v.string())),
  }))),
  to_station: v.optional(v.nullable(v.object({
    code: v.optional(v.nullable(v.string())),
    name: v.optional(v.nullable(v.string())),
  }))),
  class: v.optional(v.nullable(v.string())),
  quota: v.optional(v.nullable(v.string())),
});

const ComponentsRails = v.object({
  id: v.optional(v.nullable(v.string())),
  filters: v.optional(v.nullable(v.object({
    seen: v.optional(v.nullable(v.array(SeenItemRails))),
    applied: v.optional(v.nullable(v.array(SeenItemRails))),
  }))),
  product_list: v.optional(v.nullable(v.array(ProductItemRails))),
  time_spent: v.optional(v.nullable(v.number())),
});

const BookingInfoRails = v.object({
  booking_id: v.optional(v.nullable(v.string())),
  pnr: v.optional(v.nullable(v.string())),
  booking_status: v.optional(v.nullable(v.string())),
  total_amount: v.optional(v.nullable(v.number())),
  currency: v.optional(v.nullable(v.string())),
});

const EventDetailRails = v.object({
  event_id: v.optional(v.nullable(v.string())),
  event_timestamp: v.optional(v.nullable(v.number())),
  event_name: v.optional(v.nullable(v.string())),
  event_type: v.optional(v.nullable(v.string())),
  event_value: v.optional(v.nullable(v.string())),
  components: v.optional(v.nullable(ComponentsRails)),
  booking_info: v.optional(v.nullable(BookingInfoRails)),
});

const ExperimentDetailsRails = v.object({
  valid_exp_list: v.optional(v.nullable(v.array(v.string()))),
  variant_keys: v.optional(v.nullable(v.string())),
  honoured_exp_list: v.optional(v.nullable(v.array(v.string()))),
});

const DeviceContextRails = v.object({
  acquired_country: v.optional(v.nullable(v.string())),
  advertiser_id: v.optional(v.nullable(v.string())),
  app_install_timestamp: v.optional(v.nullable(v.number())),
  app_ver: v.optional(v.nullable(v.string())),
  build_ver: v.optional(v.nullable(v.string())),
  continent: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
  device_id: v.optional(v.nullable(v.string())),
  firebase_id: v.optional(v.nullable(v.string())),
  ip_addr: v.optional(v.nullable(v.string())),
  model: v.optional(v.nullable(v.string())),
  network_type: v.optional(v.nullable(v.string())),
  os: v.optional(v.nullable(v.string())),
  os_version: v.optional(v.nullable(v.string())),
  platform: v.optional(v.nullable(v.string())),
  time_zone: v.optional(v.nullable(v.string())),
  user_agent: v.optional(v.nullable(v.string())),
  vendor_id: v.optional(v.nullable(v.string())),
  visitor_id: v.optional(v.nullable(v.string())),
});

const UserContextRails = v.object({
  is_logged_in: v.optional(v.nullable(v.boolean())),
  profile_type: v.optional(v.nullable(v.string())),
});

const EntityInfoRails = v.object({
  currency: v.optional(v.nullable(v.string())),
  entity: v.optional(v.nullable(v.string())),
  organisation: v.optional(v.nullable(v.string())),
  region: v.optional(v.nullable(v.string())),
  user_country: v.optional(v.nullable(v.string())),
  user_currency: v.optional(v.nullable(v.string())),
  user_language: v.optional(v.nullable(v.string())),
});

const PageContextRails = v.object({
  lob: v.optional(v.nullable(v.string())),
  page_type: v.optional(v.nullable(v.string())),
  page_name: v.optional(v.nullable(v.string())),
  funnel_step: v.optional(v.nullable(v.string())),
  lob_category: v.optional(v.nullable(v.string())),
  travel_store: v.optional(v.nullable(v.object({
    store_id: v.optional(v.nullable(v.string())),
  }))),
});

// Rails-specific extended schema using Valibot
const RailsLandingPageSchema = v.object({
  page_context: v.optional(v.nullable(PageContextRails)),
  event_tracking_context: v.optional(v.nullable(EventTrackingContextRails)),
  search_context: v.optional(v.nullable(SearchContextRails)),
  event_detail: v.optional(v.nullable(EventDetailRails)),
  addon_details: v.optional(v.nullable(v.array(AddonDetailsItemRails))),
  experiment_details: v.optional(v.nullable(ExperimentDetailsRails)),
  device_context: v.optional(v.nullable(DeviceContextRails)),
  user_context: v.optional(v.nullable(UserContextRails)),
  entity_info: v.optional(v.nullable(EntityInfoRails)),
  identities: v.optional(v.nullable(v.object({}))),
});

// Export all schemas for reuse
export {
  LocusRails,
  LocationRails,
  FromRails,
  ToRails,
  SearchContextRails,
  AddonDetailsItemRails,
  EventTrackingContextRails,
  SeenItemRails,
  CatalogItemRails,
  LegRails,
  ProductItemRails,
  ComponentsRails,
  EventDetailRails,
  ExperimentDetailsRails,
  DeviceContextRails,
  UserContextRails,
  EntityInfoRails,
  PageContextRails,
  RailsLandingPageSchema,
};